/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { IngestionSearchDto } from './ingestion-search-dto';
/**
 *
 *
 * @export
 * @interface FindAllIngestionsQueryDto
 */
export interface FindAllIngestionsQueryDto {
  /**
   * @type {number}
   * @memberof FindAllIngestionsQueryDto
   */
  page?: number;

  /**
   * @type {number}
   * @memberof FindAllIngestionsQueryDto
   */
  limit?: number;

  /**
   * @type {IngestionSearchDto}
   * @memberof FindAllIngestionsQueryDto
   */
  search?: IngestionSearchDto;

  /**
   * @type {string}
   * @memberof FindAllIngestionsQueryDto
   */
  sort_field?: FindAllIngestionsQueryDtoSortFieldEnum;

  /**
   * @type {string}
   * @memberof FindAllIngestionsQueryDto
   */
  sort_order?: FindAllIngestionsQueryDtoSortOrderEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum FindAllIngestionsQueryDtoSortFieldEnum {
  IngestionDate = 'ingestion_date',
  ZipData = 'zip_data',
  Process = 'process',
  IsSession = 'is_session',
  URole = 'u_role',
  CreatedAt = 'created_at',
}
/**
 * @export
 * @enum {string}
 */
export enum FindAllIngestionsQueryDtoSortOrderEnum {
  Asc = 'asc',
  Desc = 'desc',
}
